// extracted by mini-css-extract-plugin
module.exports = {"component":"ScrollWrapper_component__3N-4Q","isLocked":"ScrollWrapper_isLocked__1XLD6"};